import React, { useRef } from 'react';
import HoldingInvestorPerformanceWidget from 'components/Widgets/HoldingInvestorPerformanceWidget';

const Sandbox = () => {
  const ref = useRef();

  return <HoldingInvestorPerformanceWidget forwardRef={ref} />;
};

export default Sandbox;
